// getSanityLocale.ts
import {useLocalization} from '@shopify/hydrogen';

export function getSanityLocale() {
  const {language} = useLocalization();
  const locale =
    language.isoCode.toLocaleLowerCase() === 'nb'
      ? 'no'
      : language.isoCode.toLocaleLowerCase();
  return locale;
}
